// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"ddbcdb47","785":"f2e7f695"}[chunkId] + ".chunk.js";
};